import {
  TextStyle,
} from "../../../domain/drawing";
import {
  IItem,
} from "../../../domain/document/items";

export interface ITextStyleReadable {
  readTextStyle(source: IItem, shouldInputFree: boolean, isFocused: boolean): TextStyle;
}

export function instanceOfITextStyleReadable(instance: any): instance is ITextStyleReadable {
  return instance
    && (instance.readTextStyle !== undefined);
}
